export const environment = {
  production: true,
  environmentText: 'Production'
};
